export default __webpack_public_path__ + "static/media/chosen-ph-colored.40c72cd1.webp";